import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './views/Home.vue';
import Detail from './views/Detail.vue';
import Search from './views/Search.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/api_reference',
    },
    {
      name: 'home',
      path: '/api_reference',
      component: Home,
    },
    {
      name: 'detail',
      path: '/api_reference/detail/:pilot/:id',
      component: Detail,
      props: true,
    },
    {
      name: 'search',
      path: '/api_reference/search/:content',
      component: Search,
      props: true,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash.includes('Limitations')) {
      return { x: 0, y: 100 };
    }
    if (to.hash.includes('Payload')) {
      return { x: 0, y: 240 };
    }
    if (to.hash.includes('Event-Triggers')) {
      return { x: 0, y: 1200 };
    }
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { y: 50 },
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
